(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  function activateNativeVariantPickers(root) {
    root.querySelectorAll('[data-native-variant-options][hidden]').forEach((wrapper) => {
      const form = wrapper.closest('form');
      const fallback = form && form.querySelector('[data-native-variant-fallback]');
      const variantSelect = fallback && fallback.querySelector('[data-variant-select]');
      const selectedVariant = variantSelect && variantSelect.selectedOptions[0];
      if (!form || !fallback || !variantSelect || !selectedVariant) return;
      let selectedValues;
      try {
        selectedValues = JSON.parse(selectedVariant.dataset.optionKey);
      } catch (error) {
        return;
      }
      const selectors = Array.from(wrapper.querySelectorAll('[data-native-option-select]'));
      selectors.forEach((select) => {
        const selectedValue = selectedValues[Number(select.dataset.optionPosition)];
        if (selectedValue !== undefined) select.value = selectedValue;
      });
      wrapper.hidden = false;
      fallback.hidden = true;
      variantSelect.setAttribute('aria-hidden', 'true');
      variantSelect.tabIndex = -1;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => activateNativeVariantPickers(document));
  } else {
    activateNativeVariantPickers(document);
  }
  document.addEventListener('shopify:section:load', (event) => activateNativeVariantPickers(event.target));

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-native-option-select]')) return;
    const form = event.target.closest('form');
    if (!form) return;
    const selectors = Array.from(form.querySelectorAll('[data-native-option-select]'));
    selectors.sort((left, right) => Number(left.dataset.optionPosition) - Number(right.dataset.optionPosition));
    const optionKey = JSON.stringify(selectors.map((select) => select.value));
    const variantSelect = form.querySelector('[data-variant-select]');
    if (!variantSelect) return;
    const variantOption = Array.from(variantSelect.options).find((option) => option.dataset.optionKey === optionKey);
    if (!variantOption) {
      const button = form.querySelector('[data-add-button]');
      if (button) {
        button.disabled = true;
        button.textContent = button.dataset.unavailableLabel;
      }
      return;
    }
    variantSelect.value = variantOption.value;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
    if (section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';

    const loadRecommendations = () => {
      fetch(section.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const replacement = parsed.querySelector(`[data-section-id="${section.dataset.sectionId}"]`);
          if (replacement && replacement.innerHTML.trim()) {
            section.innerHTML = replacement.innerHTML;
          }
        });
    };

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      loadRecommendations();
    }, { rootMargin: '0px 0px 300px 0px' });

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();
})();
